import { CreateGlossaryTermDTO, UpdateGlossaryTermDTO } from '@/generated';
import { glossaryApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('glossary-refresh');

export const useCreateGlossaryTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createGlossaryTermDTO: CreateGlossaryTermDTO) => glossaryApi.glossaryCreate({ createGlossaryTermDTO: createGlossaryTermDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.GlossaryTerms] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateGlossaryTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateGlossaryTermDTO: UpdateGlossaryTermDTO) => glossaryApi.glossaryUpdate({ updateGlossaryTermDTO: updateGlossaryTermDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.GlossaryTerms] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeleteGlossaryTerm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (glossaryTermId: string) => glossaryApi.glossaryDelete({ glossaryTermId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.GlossaryTerms] });
      //TODO: Update regression on delete
      refreshChannel.postMessage('refresh');
    },
  });
};
